export default function initListingExtraDetailsComponent(app) {
    app.component('listing-extra-details', {
        template: '#listing-extra-details',
        props: {
            modelValue: {required: true},
        },
        data() {
            return {listing: this.modelValue};
        },
        computed: {
            priceText() {
                return (!this.listing.hidePrice && this.listing.priceText) ? this.listing.priceText : this.listing.priceTypeText;
            },
        },
    });
};
